import moment from 'moment'
import momentId from 'moment/dist/locale/id'

// set language moment to indonesia
moment.updateLocale('id', momentId)

export const intlFulldatetime = function (date) {
  if (!date) return '-'

  return moment(date).format('YYYY-MM-DD, HH:mm:ss')
}
